import React, { useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { toast } from 'react-toastify';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarSimpleMethodItem } from '../../../components/commons/SideBarComponents/SimpleMethodItem/sideBarSimpleMethodButtonItem';
import { useGetDeferOnOffMethodMutation } from '../../../services/device/deviceService';
import { StyledContainerValue } from '../../locations/transferLocationBar/transferLocationBarStyles';

interface DeferOnOffMethodProps {
  locationId: number;
  reloadTable: () => void;
  setOpenRightSideBar: (open: boolean) => void;
  clearSelectedLocations: () => void;
}
export const DeferOnOffMethod = ({
  locationId,
  reloadTable,
  setOpenRightSideBar,
  clearSelectedLocations
}: DeferOnOffMethodProps) => {
  const [date, setDate] = useState(new Date());
  const [sendDeferMethod, { isLoading, isSuccess }] =
    useGetDeferOnOffMethodMutation();

  useEffect(() => {
    if (isSuccess) {
      reloadTable();
      setOpenRightSideBar(false);
      clearSelectedLocations();
      toast.success(Strings.devices.deferMethodSuccess);
    }
  }, [isSuccess]);

  const handleSendDeferMethod = (method: string) => {
    sendDeferMethod({
      date: date.toISOString(),
      locationId,
      method
    });
  };

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.locations.deferOnOffMethod}
        </StyledTitleSideBar>
        <StyledContainerValue>
          <p>Date</p>
          <Calendar
            value={date}
            onChange={(e) => setDate(e.value ?? new Date())}
            autoZIndex
            baseZIndex={1201}
            className="w-100"
            icon={<CalendarIcon />}
            touchUI
          />
        </StyledContainerValue>
        <SideBarSimpleMethodItem
          name={Strings.serverAccess.devices.sendDeferOffMethod}
          action={() => {
            handleSendDeferMethod('DeferOffCommand');
          }}
          successAction={false}
          textSuccess="success"
        />
        <SideBarSimpleMethodItem
          name={Strings.serverAccess.devices.sendDeferOnMethod}
          action={() => {
            handleSendDeferMethod('DeferOnCommand');
          }}
          successAction={false}
          textSuccess="success"
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
